import { useTranslation } from 'react-i18next'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { GlobalRole } from '@/services/api/auth'

/** Global-role picker (user / admin / superadmin) shared by the admin user dialogs. */
export function GlobalRoleSelect({
  value,
  onChange,
  disabled,
}: {
  value: GlobalRole
  onChange: (role: GlobalRole) => void
  disabled?: boolean
}) {
  const { t } = useTranslation()
  return (
    <Select value={value} onValueChange={v => onChange(v as GlobalRole)} disabled={disabled}>
      <SelectTrigger className="max-md:w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="user">{t('admin.users.roleUser')}</SelectItem>
        <SelectItem value="admin">{t('admin.users.roleAdmin')}</SelectItem>
        <SelectItem value="superadmin">{t('admin.users.roleSuperadmin')}</SelectItem>
      </SelectContent>
    </Select>
  )
}
